<template>
  <fade-in>
    <div class="work-contents-group-wrapper">
      <p class="work-contents-group-title">{{title}}</p>
      <slot></slot>
    </div>
  </fade-in>
</template>

<script>
import FadeIn from '@/components/FadeIn.vue';

export default {
  props: ['title'],
  components: { FadeIn }
}
</script>


<style lang="scss" scoped>
.work-contents-group-wrapper {
  margin: 120px auto;
  padding: 10px 20px;
}

.work-contents-group-title {
  margin: 10px 0;
}
</style>